import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import SetPasswordForm from '@zr/jobseeker-public/apps/jobseeker-collect-additional-information/components/SetPassword/SetPasswordForm';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';
import { SET_PASSWORD } from '../../../screenTypeSchema';
import screenTypeTelemetry from '../screenTypeTelemetry';

import './SetPassword.less';

function SetPasswordScreenType({
  onScreenTypeFinish,
  applyData,
  setIsLoading,
}) {
  const {
    logView,
    logFinish,
  } = screenTypeTelemetry(SET_PASSWORD, applyData);

  useEffect(() => {
    logView();
  }, [logView]);

  const handleScreenTypeFinish = async () => {
    logFinish();
    await onScreenTypeFinish();
  };

  return (
    <div className="SetPassword">
      <SetPasswordForm
        onSubmit={handleScreenTypeFinish}
        setIsLoading={setIsLoading}
      />
    </div>
  );
}

SetPasswordScreenType.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func,
};

SetPasswordScreenType.defaultProps = {
  setIsLoading: () => {},
};

export default SetPasswordScreenType;
